import { render, staticRenderFns } from "./StatsComponent.vue?vue&type=template&id=d50245cc&scoped=true"
import script from "./StatsComponent.vue?vue&type=script&lang=js"
export * from "./StatsComponent.vue?vue&type=script&lang=js"
import style0 from "./StatsComponent.vue?vue&type=style&index=0&id=d50245cc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d50245cc",
  null
  
)

export default component.exports